__turbopack_context__.v({
  "className": "libre_baskerville_5bc9a804-module__MgQBOa__className",
  "variable": "libre_baskerville_5bc9a804-module__MgQBOa__variable",
});
